// Import model
import { DataviewVinylCatalogItemResponse } from '../models/DataviewVinylCatalogItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterVinylCatalogItemRequest } from '../models/FilterVinylCatalogItemRequest';
import { VinylCatalogItem } from '../models/VinylCatalogItem';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterVinylCatalogItemRequestSerializer } from './FilterVinylCatalogItemRequestSerializer';
import { VinylCatalogItemSerializer } from './VinylCatalogItemSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewVinylCatalogItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewVinylCatalogItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewVinylCatalogItemResponse instance
   */
  static deserialize(json: string): DataviewVinylCatalogItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewVinylCatalogItemResponse instance
   */
  static fromObject(obj: any): DataviewVinylCatalogItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewVinylCatalogItemResponse');
    }


    const instance: DataviewVinylCatalogItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        VinylCatalogItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterVinylCatalogItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewVinylCatalogItemResponse instances
   */
  static deserializeArray(json: string): DataviewVinylCatalogItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewVinylCatalogItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewVinylCatalogItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewVinylCatalogItemResponse instance to a plain object
   */
  static toObject(instance: DataviewVinylCatalogItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        VinylCatalogItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterVinylCatalogItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewVinylCatalogItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewVinylCatalogItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
